(ns dre.modals.search.export.views
  (:require
   ["antd" :refer [Spin]]
   [clojure.string :as str]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.components.inputs :refer [checkbox input-text input-number]]
   [dre.components.form :refer [form form-item]]
   [dre.components.radio-group :refer [radio-group]]
   [dre.modals.search.export.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [re-frame.core :as rf]))

(defn- export-content
  []
  (let [component-name :search-export
        data @(rf/subscribe [::events/state])]
    (if (:loading? data)
      [:div
       {:style {:width "100%"
                :display "flex"
                :justify-content "center"}}
       [:> Spin]]
      [:div
       {:class [component-name]
        :style {:width "100%"}}
       [form
        {:layout "vertical"}
        [:<>
         (when (and (seq (:selected-articles data)) (not (:single-article? data)))
           [form-item
            {:label [tr "Download"]}
            [radio-group
             {:on-change #(rf/dispatch [::events/update-data [:download-type] (:value %)])
              :checked (:download-type data)
              :options events/download-options}]])
         (when (not (:single-article? data))
           [form-item
            {:label (str @(rf/subscribe [::i18n/translate "Number of citations to download (Maximum of "])
                         events/max-limit
                         @(rf/subscribe [::i18n/translate " citations)"]))}
            [input-number
             {:max events/max-limit
              :min 1
              :disabled (when (= :selected (:download-type data)) true)
              :on-change #(rf/dispatch [::events/update-data [:limit] (min events/max-limit %)])
              :value (:limit data)}]])
         [form-item
          {:label [tr "Format"]}
          [radio-group
           {:on-change (fn [e]
                         (let [new-filename (str/replace (:filename data) #".nbib|.bib|.docx|.csv" (str "." (name (:value e))))]
                           (rf/dispatch [::events/update-data [:filename] new-filename])
                           (rf/dispatch [::events/update-data [:format] (:value e)])))
            :checked (:format data)
            :options events/file-format-options}]]
         (when (or (= :docx (:format data))
                   (= :csv (:format data)))
           [form-item
            {:label [tr "Citation format"]}
            [radio-group
             {:on-change #(rf/dispatch [::events/update-data [:citation-format] (:value %)])
              :checked (:citation-format data)
              :options events/citation-format-options}]])
         (when (= :docx (:format data))
           [form-item
            {}
            [checkbox
             {:checked (:abstracts? data)
              :on-change #(rf/dispatch [::events/update-data [:abstracts?] (not (:abstracts? data))])}
             [tr "Include abstracts"]]])
         (when (or (not (:single-article? data)) (and (:single-article? data) (seq (:article/relations (:selected-article data)))))
           [form-item
            {}
            [checkbox
             {:checked (:relations? data)
              :on-change #(rf/dispatch [::events/update-data [:relations?] (not (:relations? data))])}
             [tr "Include link references"]]])
         [form-item
          {:label [tr "File Name"]}
          [input-text
           {:on-change #(rf/dispatch [::events/update-data [:filename] (-> % .-target .-value)])
            :value (:filename data)}]]]]
       (when (and (:relations? data)
                  (<= events/max-references-limit (:limit data)))
         [:div {:style {:color "red" :text-align "right"}}
          [:p "To include linked references, you may only select a maximum of 5,000 articles." [:br]
           "Please update your export to 5,000 or fewer articles or unselect linked references."]])])))

(defn export-view
  []
  (let [data @(rf/subscribe [::events/state])]
    [modal-window
     {:title "Download citations"
      :content export-content
      :submit? true
      :submit-text [tr "Export"]
      :submit-disabled? (:loading? data)
      :on-submit (fn [_]
                   (if (and (:relations? data)
                            (<= events/max-references-limit (:limit data)))
                     (js/alert "To include linked references, you may only select a maximum of 5,000 articles. Please update your export to 5,000 or fewer articles or unselect linked references.")
                     (rf/dispatch [::events/export])))}]))
